import { createStore } from "vuex";
import { geoService } from "@/services";
export default createStore({
  state: {
    regions: [],
    cities: [],
    districts: [],

    selectedRegion: {
      id: 3,
      title: "Астана қаласы",
      lat: "51.133333",
      lng: "71.433333",
    },

    prayerTimes: null,
  },
  getters: {},
  mutations: {
    setState(state, payload) {
      state[payload.key] = payload.value;
    },
  },
  actions: {
    async checkSelectedRegion(context) {
      const sr = localStorage.getItem("selectedRegion");
      if (sr) {
        context.commit("setState", {
          key: "selectedRegion",
          value: JSON.parse(sr),
        });
      }

      context.dispatch("getPrayerTimes");
    },
    async selectRegion({ dispatch, commit }, region) {
      commit("setState", {
        key: "selectedRegion",
        value: region,
      });
      localStorage.setItem("selectedRegion", JSON.stringify(region));
      dispatch("getPrayerTimes");
    },
    async getPrayerTimes({ state, commit }) {
      const response = await geoService.getPrayerTimes(
        state.selectedRegion.lat,
        state.selectedRegion.lng
      );

      commit("setState", {
        key: "prayerTimes",
        value: response,
      });
    },
    async getRegions(context) {
      const response = await geoService.getRegions();
      console.log(response.results);
      context.commit("setState", {
        key: "regions",
        value: response.results,
      });
    },
    async getCities(context, regionId) {
      const response = await geoService.getCities(regionId);
      context.commit("setState", {
        key: "cities",
        value: response.cities,
      });
    },
    async getDistricts(context, regionId) {
      const response = await geoService.getDistricts(regionId);
      context.commit("setState", {
        key: "districts",
        value: response.results,
      });
    },
    async searchRegions(context, query) {
      const response = await geoService.searchRegions(query);
      context.commit("setState", {
        key: "districts",
        value: response.results,
      });
    },
  },
  modules: {},
});
